import DataSheet from "./DataSheet.vue";
import PatientProgress from "./PatientProgress.vue";

export default {
  install(Vue) {
    Vue.component("fp-research-data-sheet", DataSheet);
    Vue.component("fp-research-patient-progress", PatientProgress);
  },
};
